module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/join-bg-8d0394c4e88c643c3e7dc30d74eebf85.jpg";